import * as t from 'io-ts';
export var Group = t.type({
  uuid: t.string,
  name: t.string
});
export var Groups = t.type({
  results: t.array(Group)
});